import classNames from 'classnames';
import { Form } from 'formik';
import { FC, forwardRef, PropsWithChildren } from 'react';
import { Button } from '../Button';
import { InputWithFormik } from '../Input/InputWithFormik';
import styles from './index.module.scss';

interface SearchFormBaseProps {
  onResetInputSearch?: () => void;
  searchButtonText?: string;
  className?: string;
  placeholder?: string;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  fieldName: string;
  autofocus: boolean;
}

export const SearchFormBase = forwardRef<HTMLFormElement, PropsWithChildren<SearchFormBaseProps>>(
  (
    { onResetInputSearch, children, className, placeholder = '', onSubmit, fieldName, autofocus },
    ref,
  ) => (
    <Form className={classNames(styles.searchForm, className)} onSubmit={onSubmit} ref={ref}>
      <div className={styles.searchFormInputWrapper}>
        <InputWithFormik
          name={fieldName}
          placeholder={placeholder}
          onResetCallback={onResetInputSearch}
          // eslint-disable-next-line
          autoFocus={autofocus}
        />
      </div>
      <div className={styles.searchFormChildren}>{children}</div>
    </Form>
  ),
);
